import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { GeneralService } from '@shared/services/general.service';
import { SnackbarService, SnackbarType } from '@shared/services/snackbar.service';
import { TokenService } from '@shared/services/token.service';

export const identityGuard: CanActivateFn = (route, state) => {
  const generalService = inject(GeneralService);
  const tokenService = inject(TokenService);
  const snackbarService = inject(SnackbarService);

  if (generalService.isBrowserOnly) {
    if (tokenService.getRtk()?.length) {
      if (tokenService.userInfo()?.name === 'null null') {
        generalService.router.navigateByUrl('/register/personal-info');
        setTimeout(() => {
          snackbarService.showSnackbar(
            'برای استفاده از سایت اطلاعات خود را وارد نمایید.',
            SnackbarType.warning,
          );
        }, 500);
        return false;
      } else if (
        (tokenService.userInfo()?.kids.length ?? 0) !== (tokenService.userInfo()?.kidsCount ?? 0)
      ) {
        generalService.router.navigateByUrl('/register/personal-info');
        setTimeout(() => {
          snackbarService.showSnackbar(
            'برای استفاده از سایت اطلاعات فرزندان خود را وارد نمایید.',
            SnackbarType.warning,
          );
        }, 500);
        return false;
      } else return true;
    } else {
      return true;
    }
  }
  generalService.router.navigateByUrl('/register/personal-info');
  return false;
};
